export const MESSAGES = {
  NON_SMOKEBALL_DOCUMENT: "Non-Smokeball document loaded",
  MATTER_NOT_FOUND: "Matter not found",
  LOADING_MATTER_DATA: "Loading matter data...",
  SUCCESSFUL: "successful",
  FAILED: "failed",
  AUTOMATE_FIELDS: "Automate Fields Now",
  TRY_AGAIN: "Please Try Again",
  AUTOMATION_IN_PROGRESS: "Field automation in progress...",
  AUTOMATION_ON_HOLD: "Automation on hold",
  AUTOMATION_CANT_PROCEED: "Automation cannot proceed",
  SAVE_DOCUMENT_TO_MATTER_SUCCEED: "The document was successfully saved to the matter.",
  SAVE_DOCUMENT_TO_MATTER_MISSING_CUSTOM_PROPERTIES:
    "The information required to save the document to the matter is missing.",
  SAVE_DOCUMENT_TO_MATTER_OTHER_ERROR: "Technical error. Please contact support for further assistance",
  MATTER_DATA_UNAVAILABLE: "Matter Data Unavailable",
  SAVING_TO_MATTER: "Saving to matter...",
  SAVING_TO_MATTER_ERROR: "The document cannot be saved.",
  INVALID_MATTER_ID: "The associated matter for this document could not be found.",
  ASSIGNING_TO_MATTER: "Assigning to matter...",
  INVALID_ACCOUNT_ID: "The associated firm for this document does not exist.",
  CONNECT_PROMPT: "Please connect to Smokeball",
  SAVE_TO_MATTER_USAGE: "to use the 'Save to Matter' feature",
  SUPPORT_INFO: "If you need assistance, contact Support",
};
